import React from "react";

import styles from "./Guernsey.module.scss";

export const StyledGuernseyTr: React.FC<
  React.HTMLAttributes<HTMLTableRowElement>
> = ({ children, className, ...rest }) => (
  <tr className={`${styles.styledGuernseyTr} ${className ?? ""}`} {...rest}>
    {children}
  </tr>
);
